/**
 * Client fuer den LLM-Modellkatalog (#93).
 */
import { API_BASE_URL, API_ENDPOINTS } from '../config/api';
import { apiRequest, normalizeListResponse } from './httpClient';

export async function getLlmModels() {
  const data = await apiRequest(`${API_BASE_URL}${API_ENDPOINTS.LLM.MODELS}`);
  return normalizeListResponse(data, { source: 'getLlmModels' });
}
